import React, { MouseEventHandler } from "react"
import { buttonChildren, buttonClass, buttonStyle, BaseButtonProps } from "./base-buttons"

export interface ButtonProps extends BaseButtonProps {
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  submit?: boolean;
}

const Button: React.FC<ButtonProps> = (props: ButtonProps) => {
  const type = props.submit ? "submit" : "button"
  return (
    <button
      data-tooltip={props.dataTooltip}
      className={buttonClass(props)}
      disabled={props.disabled}
      id={props.id}
      onClick={props.onClick}
      style={buttonStyle(props)}
      type={type}
    >
      {buttonChildren(props)}
    </button>
  )
}

export default Button
